<template lang="pug">
b-container#page.notifications
  b-row
    .col-4
      //h1 {{ msg }}
      h2 Nueva notificación
      b-form(v-if="show" inline)
        b-form-group#input-counter-group(label='Counter:' description="¡Buenos dias!")
          b-form-input#input-counter.mr-sm-2(v-model="user.email" size='sm' placeholder='Usuario' disabled)
          b-button.my-2.my-sm-0(size='sm' type='submit') Salir
      h3(v-if="this.$cookies.get('role') == 'admin'") Datos de la notificación
      b-form(v-if="this.$cookies.get('role') == 'admin' && show" @submit='onSubmit' @reset='onReset')
        b-form-group#input-message-group(label='Mensaje:' label-for='input-message')
          b-form-input#input-message(v-model='form.message' /*required=''*/ placeholder='Mensaje de notificación')
        b-form-group#input-style-group(label='Estilo de notificación:' label-for='input-style')
          b-form-select#input-style(v-model='form.style' :options="styles" placeholder='Estilo de notificación' :disabled="!editable")
        b-form-group#input-startDate-group(label='Fecha de inicio:' label-for='input-startDate')
          b-form-datepicker#input-startDate(v-model="form.startDate")
        b-form-group#input-endDate-group(label='Fecha de fin:' label-for='input-endDate')
          b-form-datepicker#input-endDate(v-model="form.endDate")
        b-form-group#input-file-group(label='Archivo:' label-for='input-file')
          input(type="file" :disabled="!editable")
        b-form-group#input-link-group(label='Enlace web:' label-for='input-link')
          b-form-input#input-link(v-model='form.link' placeholder='Enlace web')
        b-form-group#submit-group
          b-button.mr-sm-2(type='submit' variant='primary') Crear notificación
    .col-8
      h2 Notificaciones
      b-alert(variant="success" show v-for="notification in notifications") {{ notification.message }}
</template>

<script>
import { mapState, mapGetters } from "vuex";

export default {
  name: "Notifications",
  /*props: {
    airports: Array,
  },*/
  computed: {
    ...mapState(["user", "airports", "notifications"]),
    ...mapGetters(["user", "airports", "notifications"]),
    editable() {
      return true; //this.input || this.isEditable;
    },
  },
  data() {
    return {
      form: {
        message: "",
        sytle: "",
        startDate: "",
        endDate: "",
        file: "",
        link: "",
      },
      show: true,
      styles: ["Info", "Warning"],
    };
  },
  async mounted() {
    await this.$store.dispatch("getNotifications");
  },
  methods: {
    async onSubmit(evt) {
      evt.preventDefault();

      try {
        this.$store.dispatch("addNotification", this.form);
      } catch (error) {
        console.log(error);
      } finally {
        console.log("notificationSubmited");
      }

      /*alert(this.form);
      this.$store.dispatch("addOperation", {
        clientId: {
          firstName: this.form.firstName,
        },
        passangerGroupID: {
          passengerNumber: this.form.passengerNumber,
        },
      });
      //this.$store.dispatch("loadItems");
      alert(JSON.stringify(this.form));*/
    },
    onReset(evt) {
      evt.preventDefault();

      // Reset our form values
      this.form.email = "";
      this.form.message = "";
      this.form.airlineCode = "";
      this.form.searchLocation = "";
      this.form.locationDate = "";
      this.form.locationTime = "";
      this.form.destinations = [];
      this.form.startDate = "";
      this.form.endDate = "";
      this.form.file = "";
      this.form.currency = "";
      this.form.total = "";

      // Trick to reset/clear native browser form validation state
      this.show = false;
      this.$nextTick(() => {
        this.show = true;
      });
    },
  },
};
</script>
